var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 6.5,
    fill: "white",
    stroke: "#2676C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2226 30.778L13.2226 23.778C12.7925 23.348 12.7925 22.6526 13.2226 22.2225L20.2226 15.2225C20.6526 14.7925 21.3479 14.7925 21.7779 15.2225C22.208 15.6526 22.208 16.348 21.7779 16.778L16.6557 21.9003H32.0002C32.6085 21.9003 33.1002 22.3921 33.1002 23.0003C33.1002 23.6085 32.6085 24.1003 32.0002 24.1003H16.6557L21.7779 29.2225C22.208 29.6526 22.208 30.348 21.7779 30.778C21.5635 30.9925 21.2817 31.1003 21.0002 31.1003C20.7187 31.1003 20.437 30.9925 20.2226 30.778Z",
    fill: "#0B4B84",
    stroke: "#0B4B84",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousBtn);
export default __webpack_public_path__ + "static/media/previous-btn.d8c163bf2461d6bdd11602307e13e0de.svg";
export { ForwardRef as ReactComponent };